import { isSameDay } from 'date-fns';
import { create } from 'zustand';
import { MyEventDay } from '../models/MyEvents.model';

interface MyEventsState {
  myEventsList: MyEventDay[];
  setMyEventsList: (myEventsList: MyEventDay[]) => void;
  selectedDay: MyEventDay | null;
  setSelectedDay: (selectedDay: MyEventDay) => void;
  resetEvent: () => void;
}

export const useMyEventsStore = create<MyEventsState>((set) => {
  const myEventsList: MyEventDay[] = [];

  const selectedDayIndex = myEventsList.findIndex((event) =>
    isSameDay(new Date(event.day), new Date())
  );

  return {
    myEventsList,
    setMyEventsList: (myEventsList: MyEventDay[]) => set({ myEventsList }),
    selectedDay: selectedDayIndex !== -1 ? myEventsList[selectedDayIndex] : null,
    setSelectedDay: (selectedDay: MyEventDay) => set({ selectedDay }),
    resetEvent: () => set({ myEventsList: [], selectedDay: null })
  };
});
